import { render, staticRenderFns } from "./StatementOfAccount.vue?vue&type=template&id=43a52155&"
import script from "./StatementOfAccount.vue?vue&type=script&lang=js&"
export * from "./StatementOfAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports